export enum ProfileStatusFieldEnum {
    phone = "phone",
    photo = "photo",
    email = "email",
    // contact_email = "contact_email",
    // contact_phone = "contact_phone",
}